import React, { useState, useEffect } from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { getListDanhSachKiemKho } from "../../actions/DanhSachKiemKho";

export const TableDanhSachKiemKho = ({ quyenXemChiTiet, quyenInChiTiet }) => {
  //Code
  const dispatch = useDispatch();
  const listDsKiemKhoFull = useSelector(
    (state) => state.listDanhSachKiemKhoFull
  ); //listTaiSanFul dinh nghia o rootreducer
  const dataSearch = useSelector((state) => state.dataSearchDanhSachKiemKho); //dataSearchTaiSan dinh nghia o rootreducer
  // {
  //   console.log(listDsKiemKhoFull);
  // }
  // API trả toàn bộ biên bản (không phân trang) nên phân trang phía client
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  useEffect(() => {
    dispatch(getListDanhSachKiemKho(dataSearch));
  }, []);
  useEffect(() => {
    setPageIndex(1);
  }, [listDsKiemKhoFull.List]);

  const loadTaiSan = () => {
    getListDanhSachKiemKho(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    setPageIndex(pageNumber);
    loadTaiSan();
  };
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPageIndex(1);
  };
  const TotalQuantity = listDsKiemKhoFull.TotalQuantity;
  const startIndex = (pageIndex - 1) * pageSize;
  const pageList = (listDsKiemKhoFull.List || []).slice(
    startIndex,
    startIndex + pageSize
  );
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile   table-mobile-hover table-responsive-new ">
              <div className="custom-table-wrapper">
                <div
                  className="table-headers"  style={{ position: "sticky", padding: "2px", top: "0rem", zIndex: "999", background:"#FFFFFF", padding:"1px 0"}}
                >
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listDsKiemKhoFull.TotalQuantity} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  text-center">Thời gian</p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="text-center">Mã</p>
                  </div>

                  <div className="custom-table-header flex-basis-40 flex-basis-40-sm">
                    <p className="text-left">Người kiểm</p>
                  </div>

                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header text-left">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listDsKiemKhoFull={pageList}
                    quyenXemChiTiet={quyenXemChiTiet}
                    quyenInChiTiet={quyenInChiTiet}
                    startIndex={startIndex}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={pageIndex}
            pageSize={pageSize}
            totalCount={TotalQuantity}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
